import { classicFilms } from "@/mocks/films";
import SectionHeading from "./SectionHeading";

export default function Classics() {
  return (
    <section id="classics" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="经典高分合集"
          title="经得起重看的经典之作"
          desc="时间是最严格的筛选器。这些作品上映多年后仍被反复讨论，讨论的早已不只是剧情，而是它们提出的那些问题。"
        />

        <div className="mt-8 flex flex-col gap-6">
          {classicFilms.map((film, index) => {
            const reversed = index % 2 === 1;
            return (
              <article
                key={film.title}
                className="grid grid-cols-1 gap-5 overflow-hidden rounded-lg border border-background-200 bg-background-100/60 p-4 md:grid-cols-2 md:items-center md:p-5"
              >
                <div
                  className={`h-48 w-full overflow-hidden rounded-md border border-background-200 md:h-64 ${
                    reversed ? "md:order-2" : ""
                  }`}
                >
                  <img
                    src={film.image}
                    alt={`《${film.title}》影片氛围示意`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className={reversed ? "md:order-1" : ""}>
                  <div className="flex items-center gap-2">
                    <span className="rounded-full bg-primary-100 px-2.5 py-1 text-xs font-label text-primary-800">
                      {film.genre}
                    </span>
                    <span className="text-xs font-label text-foreground-500">
                      {film.year}
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-xl font-bold text-foreground-950">
                    {film.title}
                  </h3>
                  <p className="mt-0.5 text-xs font-label text-foreground-500">
                    {film.original} · 导演 {film.director}
                  </p>
                  <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                    {film.summary}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}